import { current_plan_lft } from "assets/images";
import React, { useEffect, useState } from "react";

import "./Current_Plan.css";
import useFullPageLoader from "common/UseFullPageLoader";
import { subscriptionPurchaseApi } from "services/subscription";
import { dateFormat } from "utils/dateFormat";

const Current_Plan = ({ userId }) => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const [subscription, setSubscription] = useState({});

  const fetchData = async () => {
    try {
      onShow();
      const { data, status } = await subscriptionPurchaseApi({ _id: userId });
      if (status === 200) {
        setSubscription(data?.data);

      }
    } catch (e) {
      console.log(e);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="current_plan_parent">
        <div className="current_plan_child">
          <div className="row">
            <div className=" col-lg-4 col-md-4 col-sm-6">
              {
                subscription
                  ?
                  <div className="current_plan_header">
                    <div className="plan_wraper">
                      <div className="img_wraper">
                        <span className="current_plan_img">
                          <img
                            src={current_plan_lft}
                            alt=""
                            className="plan_img_lft"
                          />
                          {/* <img
                            src={current_plan_lft}
                            alt=""
                            className="plan_img_rgt"
                          /> */}
                        </span>
                        <p className="count">$ {subscription?._subscriptionPrice?.price}</p>
                      </div>

                      <div className="plan_btn_wrap">
                        <p>
                          Expiry Date: <span>{dateFormat(subscription?.expiryAt)}</span>
                        </p>
                        {/* <button className="button expiry_date_btn">
                          Extend Expiry Date
                        </button> */}
                      </div>
                    </div>
                    <div className="plan_wraper_content">
                      <h2>{subscription?._subscriptionPrice?.name}</h2>

                      <div className="plan_wraper_text">
                        <p 
                         dangerouslySetInnerHTML={{__html: subscription?._subscriptionPrice?.description}} />
                          
                      </div>

                      {/* <div className="plan_wraper_footer">
                        <button className="button">Cancel Plan</button>
                      </div> */}

                    </div>
                  </div>
                  :
                  null
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Current_Plan;
